import React from "react";
import {
  Grid,
  Container,
  Card,
  Typography,
} from "@material-ui/core";
import { TyCStyles } from "./TyCStyles";
import { useTranslation } from "react-i18next";
import { EnumPrivacyTyC } from "../../../commons/EnumsGeneral";

export function GeneralUseConditions(props) {
  const classes = TyCStyles();
  const { t } = useTranslation(); //delete i18n (asigned but never used)

  return (
    <Grid
      className={
        !props.showSideMenu ? classes.container : classes.hideContainer
      }
    >
      <Container maxWidth={"lg"} className={classes.mainContainer}>
        <Card className={classes.cardContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography align="justify" className={classes.text}>
                  <h2 className={classes.title}>{t("privacyPolicyTitle00")}</h2>
                  <hr></hr>
                  <br></br>
                  <p>{t("privacyPolicyText00_01")}</p>
                  <p>{t("privacyPolicyText00_02")}</p>
                  <p>{t("privacyPolicyText00_03")}</p>
                  <p>{t("privacyPolicyText00_04")}</p>

                  <p className={classes.subtitles}>{t("privacyPolicyTitle0x")}</p>
                  <h5 className={classes.subtitles}>{t("privacyPolicyTitle01")}</h5>
                  <p>{t("privacyPolicyText01_01")}</p>

                  <h5 className={classes.subtitles}>{t("privacyPolicyTitle02")}</h5>
                  <p>{t("privacyPolicyText02_01")}</p>
                  <p>{t("privacyPolicyText02_02")}</p>
                  <ul type="square">
                    <li>
                      <p>{t("privacyPolicyText02_03")}</p>
                    </li>
                    <li>
                      <p>{t("privacyPolicyText02_04")}</p>
                    </li>
                    <li>
                      <p>{t("privacyPolicyText02_05")}</p>
                    </li>
                  </ul>
                  <p>{t("privacyPolicyText02_06")}</p>

                  <h5 className={classes.subtitles}>{t("privacyPolicyTitle03")}</h5>
                  <p>{t("privacyPolicyText03_01")}</p>
                  <ol>
                    <li>
                      <p>{t("privacyPolicyText03_02a")}<b><a href={EnumPrivacyTyC.DataProtectionPolicy} className={classes.links} target="_blank" rel="noopener noreferrer">{t("privacyPolicyText03_02b")}</a></b>{t("privacyPolicyText03_02c")}</p>
                    </li>
                    <li>
                      <p>{t("privacyPolicyText03_03")}</p>
                      <p>{t("privacyPolicyText03_04")}</p>
                      <p>{t("privacyPolicyText03_05")}</p>
                      <p>{t("privacyPolicyText03_06a")}<b><a href="https://www.correos.es/es/es/atencion-al-cliente" className={classes.links} target="_blank" rel="noopener noreferrer">{t("privacyPolicyText03_06b")}</a></b>{t("privacyPolicyText03_06c")}</p>

                    </li>
                    <li>
                      <p>{t("privacyPolicyText03_07")}</p>
                    </li>
                    <li>
                      <p>{t("privacyPolicyText03_08")}</p>
                    </li>
                  </ol>
                  <p>{t("privacyPolicyText03_09")}</p>

                  <h5 className={classes.subtitles}>{t("privacyPolicyTitle04")}</h5>
                  <p>{t("privacyPolicyText04_01")}</p>
                  <ol>
                    <li>
                      <p>{t("privacyPolicyText04_02")}</p>
                    </li>
                    <li>
                      <p>{t("privacyPolicyText04_03")}</p>
                      <p>{t("privacyPolicyText04_04")}</p>
                      <p>{t("privacyPolicyText04_05")}</p>
                    </li>
                    <li>
                      <p>{t("privacyPolicyText04_06")}</p>
                    </li>
                    <li>
                      <p>{t("privacyPolicyText04_07")}</p>
                    </li>
                  </ol>
                  <p>{t("privacyPolicyText04_08")}</p>
                  <p>{t("privacyPolicyText04_09")}</p>
                  <p>{t("privacyPolicyText04_10")}</p>

                  <h5 className={classes.subtitles}>{t("privacyPolicyTitle05")}</h5>
                  <p>{t("privacyPolicyText05_01")}</p>
                  <p>{t("privacyPolicyText05_02a")}<b><a href="https://www.correos.es/es/es/atencion-al-cliente" className={classes.links} target="_blank" rel="noopener noreferrer">{t("privacyPolicyText05_02b")}</a></b>{t("privacyPolicyText05_02c")}</p>
                  <p>{t("privacyPolicyText05_03")}</p>
                  <ul type="square">
                    <li>
                      <p>{t("privacyPolicyText05_04")}</p>
                    </li>
                    <li>
                      <p>{t("privacyPolicyText05_05")}</p>
                    </li>
                    <li>
                      <p>{t("privacyPolicyText05_06")}</p>
                    </li>
                    <li>
                      <p>{t("privacyPolicyText05_07")}</p>
                    </li>
                    <li>
                      <p>{t("privacyPolicyText05_08")}</p>
                    </li>
                  </ul>
                  <p>{t("privacyPolicyText05_09")}</p>
                  <ul type="square">
                    <li>
                      <p>{t("privacyPolicyText05_10")}</p>
                    </li>
                    <li>
                      <p>{t("privacyPolicyText05_11")}</p>
                    </li>
                    <li>
                      <p>{t("privacyPolicyText05_12")}</p>
                    </li>
                    <li>
                      <p>{t("privacyPolicyText05_13")}</p>
                    </li>
                    <li>
                      <p>{t("privacyPolicyText05_14")}</p>
                    </li>
                    <li>
                      <p>{t("privacyPolicyText05_15")}</p>
                    </li>
                    <li>
                      <p>{t("privacyPolicyText05_16")}</p>
                    </li>
                  </ul>

                  <h5 className={classes.subtitles}>{t("privacyPolicyTitle06")}</h5>
                  <p>{t("privacyPolicyText06_01a")}<b><a href="https://mioficina.correos.es/es/es/login" className={classes.links} target="_blank" rel="noopener noreferrer">{t("privacyPolicyText06_01b")}</a></b>{t("privacyPolicyText06_01c")}</p>
                  <p>{t("privacyPolicyText06_02")}</p>
                  <p>{t("privacyPolicyText06_03")}</p>

                  <h5 className={classes.subtitles}>{t("privacyPolicyTitle07")}</h5>
                  <p>{t("privacyPolicyText07_01a")}<b><a href={EnumPrivacyTyC.DataProtectionPolicy} className={classes.links} target="_blank" rel="noopener noreferrer">{t("privacyPolicyText07_01b")}</a></b>{t("privacyPolicyText07_01c")}</p>

                  <h5 className={classes.subtitles}>{t("privacyPolicyTitle08")}</h5>
                  <p>{t("privacyPolicyText08_01")}</p>
                  <p>{t("privacyPolicyText08_02")}</p>
                  <p>{t("privacyPolicyText08_03")}</p>
                  <p>{t("privacyPolicyText08_04")}</p>

                  <h5 className={classes.subtitles}>{t("privacyPolicyTitle09")}</h5>
                  <p>{t("privacyPolicyText09_01")}</p>
                  <p>{t("privacyPolicyText09_02")}</p>
                  <p>{t("privacyPolicyText09_03")}</p>

                  <h5 className={classes.subtitles}>{t("privacyPolicyTitle10")}</h5>
                  <p>{t("privacyPolicyText10_01")}</p>
                  <p>{t("privacyPolicyText10_02")}</p>
                  <p>{t("privacyPolicyText10_03")}</p>

                  <h5 className={classes.subtitles}>{t("privacyPolicyTitle11")}</h5>
                  <p>{t("privacyPolicyText11_01")}</p>

                  <h5 className={classes.subtitles}>{t("privacyPolicyTitle12")}</h5>
                  <p>{t("privacyPolicyText12_01")}</p>
              </Typography>
            </Grid>
          </Grid>
        </Card>
      </Container>
    </Grid>
  );
}
